// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationService } from '../../../../services/notification.service';
import { AuthService } from '../../../auth/_services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments';
import { StringFormatPipe } from '../../layout/pipes/string-format.pipe';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';

/*
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {

	/**
	 *
	 */
	constructor(
		private router: Router,
		private authService: AuthService,
		private _notificationService: NotificationService,
		private _translateService: TranslateService,
		private stringFormat: StringFormatPipe,
		private dialog: MatDialog
	) {
	}

	/**
	 *
	 */
	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// tslint:disable-next-line:no-debugger
		// modify request
		const minutesFromUTC = moment().utcOffset();
		if (request.url.search('/authorize') === -1)
			
			request = request.clone({
				setHeaders: {
					Authorization: this.authService.getAuthorizationHeaderValue(),
					TenantId: environment.tenantId.toString(),
					MinutesFromUTC: minutesFromUTC.toString()
				}
			});
		// request = request.clone({
		// 	setHeaders: {
		// 		Authorization: `Bearer ${localStorage.getItem('accessToken')}`
		// 	}
		// });
		// console.log('----request----');
		// console.log(request);
		// console.log('--- end of request---');

		return next.handle(request).pipe(
			tap(
				event => {
					if (event instanceof HttpResponse) {
						// console.log('all looks good');
						// http response status code
						// console.log(event.status);
					}
				},
				error => {
					// Check if error is Blob
					if (error.error instanceof Blob) {
						const reader = new FileReader();
						reader.addEventListener("loadend", () => {
							// reader.result contains the contents of blob as a string
							const err = JSON.parse(reader.result as string);
							return this.parseError({ ...error, error: err });
						});
						reader.readAsText(error.error);
					} else {
						return this.parseError(error);
					}
				}
			)
		);
	}

	parseError(error) {
		// Access forbidden
		// ver que la api esté mandando bien el 403 cuando no esta autorizado
		if (error.status == 401) {
			this.dialog.closeAll();
			this.authService.enforceLogin(error.err == undefined ? (error.error.ErrorCode == undefined ? "" : error.error.ErrorCode) : error.err);
		}
		else if (error.status == 403) {
			this.dialog.closeAll();
			this.router.navigate(['unauthorized']);
		}
		// Bussiness errors
		else if (error.status == 400 || error.status == 404) {
			this._notificationService.openSnackBar(this._translateService.instant(`BUSSINESSERRORS.${error.error.ErrorCode}`));
		}
		// Server error
		else if (error.status == 500) {
			this._notificationService.openSnackBar(this._translateService.instant(`BUSSINESSERRORS.${error.error.ErrorCode}`));
		}
		return error;
	}

	parseErrorMessageFromCode(errorCode: string): string {
		if (errorCode.split(':').pop().match(new RegExp('\\d+Times'))) {
			var times: number = Number.parseInt(errorCode.split(':').pop().split('T').shift());
			var msg = this._translateService.instant('BUSSINESSERRORS.ErrThirPartyCannotExtendMoreThan:XTimes')
			return this.stringFormat.transform(msg, times);
		}
		else
			return this._translateService.instant(`BUSSINESSERRORS.${errorCode}`);
	}
}

function _throw(error: any) {
	throw new Error('Function not implemented.');
}
